import { render, staticRenderFns } from "./product-commision.vue?vue&type=template&id=20d45f46&scoped=true&"
import script from "./product-commision.vue?vue&type=script&lang=js&"
export * from "./product-commision.vue?vue&type=script&lang=js&"
import style0 from "./product-commision.vue?vue&type=style&index=0&id=20d45f46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d45f46",
  null
  
)

export default component.exports